import React from 'react'
import { Region } from '@enonic/react-components';

import Section from '../../../react4xp/components/Section'
import LandingPageHero from '../../../react4xp/components/LandingPageHero'
import RichText from '../../../react4xp/components/RichText'

function LandingPageLayout(props) {
  
	const {	tag,
		 	title, 
			intro, 
			image,
			imageLarge, 
			heroVariation, 
			backgroundColor, 
			text, 
			regions,
			slidingLink,
			internalLink
		} = props
    
	return (
		<>
			<Section bgColor={backgroundColor === 'beige' ? 'bg-beige-primary-dark' : backgroundColor === 'light-beige' ? 'bg-beige-primary-light' :  'bg-green-secondary-dark'} >
				<LandingPageHero
					tag={tag}
					title={title} 
					intro={intro}
					color={backgroundColor}
					isLarge={heroVariation === 'large'}
					img={image}
					imgLarge={imageLarge}
					slidingLink={slidingLink}
					internalLink={internalLink}
				/>
			</Section>
			{text && (
				<Section bgColor={(backgroundColor === 'beige' || backgroundColor === 'light-beige') ? 'bg-beige-primary-light' : 'bg-green-secondary-light'} >
					<div className="landing-page__html-area">
					<div className="grid-container">
						<div className="grid-row">
						<div className="c-sm-8 start-sm-3">
							<RichText content={text} />
						</div>
						</div>
					</div>
					</div>
				</Section>
			)}
			<Region name={regions.main.name} regionData={regions.main} />
		</>
	)
}

export default (props) => <LandingPageLayout {...props} />
